import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

export default withStyles({
  tooltip: {
    fontSize: '15px',
  },
})(Tooltip);
